import { useState } from 'react';
import { Icon } from 'src/components/Icon';
import Avatar from 'src/components/Misc/Avatar';
import { useI18nContext } from 'src/i18n/i18n-react';
import { trpc } from 'src/lib/trpc';
import LogIn04 from 'src/assets/svgicons/duocolor/log-in-04.svg';
import Building06 from 'src/assets/svgicons/duocolor/building-06.svg';
import LifeBuoy02 from 'src/assets/svgicons/duocolor/life-buoy-02.svg';
import SwitchHorizontal02 from 'src/assets/svgicons/duocolor/switch-horizontal-02.svg';
import UserCircle from 'src/assets/svgicons/duocolor/user-circle.svg';
import { HELP_LINK } from 'src/static/links';
import { segment } from 'src/lib/segment';
import { Menu, MenuItem, MenuItemGroup } from '../Menu/Menu';
import Spinner from '../Loaders/Spinner';
import SwitchWorkspaceModal from './components/SwitchWorkspaceModal';

const UserMenuDropdown: React.FunctionComponent = () => {
  const { LL } = useI18nContext();
  const [isWorkspaceModalOpen, setIsWorkspaceModalOpen] = useState(false);
  const user = trpc.user.getUserInfo.useQuery();
  const currentOrg = trpc.organisation.getOrganisation.useQuery();

  return (
    <>
      <SwitchWorkspaceModal
        currentOrg={currentOrg.data}
        show={isWorkspaceModalOpen}
        onClose={() => setIsWorkspaceModalOpen(false)}
      />
      <Menu
        as="button"
        items={
          <>
            {user.data?.email && (
              <MenuItemGroup>
                <div className="px-4 py-3 text-primary">
                  <p className="text-sm font-semibold">{LL.signedInAs()}</p>
                  <p className="truncate text-sm font-normal">
                    {user.data.email}
                  </p>
                </div>
              </MenuItemGroup>
            )}
            <MenuItemGroup>
              <div className="flex flex-row gap-3 px-4 py-3 text-primary">
                {currentOrg.data?.profilePicURL && (
                  <div className="h-10 w-10 items-center justify-center overflow-hidden rounded-lg">
                    <img
                      alt=""
                      className="h-full object-cover"
                      src={currentOrg.data.profilePicURL}
                    />
                  </div>
                )}
                <div className="shrink overflow-hidden">
                  <p className="text-sm font-semibold">
                    {LL.currentWorkspace()}
                  </p>
                  {currentOrg.isLoading ? (
                    <div className="text-primary">
                      <Spinner />
                    </div>
                  ) : (
                    <p className="truncate text-sm font-normal">
                      {currentOrg.data?.name}
                    </p>
                  )}
                </div>
              </div>
              <MenuItem.Button
                onClick={() => setIsWorkspaceModalOpen(true)}
                icon={
                  <Icon>
                    <SwitchHorizontal02 />
                  </Icon>
                }
              >
                {LL.workspaceSwitcher.title()}
              </MenuItem.Button>
            </MenuItemGroup>
            <MenuItemGroup>
              <MenuItem.ReactRouterLink
                icon={
                  <Icon>
                    <UserCircle />
                  </Icon>
                }
                to="/profile"
              >
                {LL.yourProfile()}
              </MenuItem.ReactRouterLink>
              <MenuItem.ReactRouterLink
                icon={
                  <Icon>
                    <Building06 />
                  </Icon>
                }
                to="/settings"
              >
                {LL.workspace()}
              </MenuItem.ReactRouterLink>
              <MenuItem.ExternalLink
                icon={
                  <Icon>
                    <LifeBuoy02 />
                  </Icon>
                }
                href={HELP_LINK}
                onClick={() => void segment?.track('viewed_help')}
              >
                {LL.help()}
              </MenuItem.ExternalLink>
            </MenuItemGroup>
            <MenuItemGroup>
              <MenuItem.ReactRouterLink
                to="/logout"
                activeClassName="text-danger bg-red-50"
                inactiveClassName="text-danger"
                icon={
                  <Icon>
                    <LogIn04 />
                  </Icon>
                }
              >
                {LL.signOut()}
              </MenuItem.ReactRouterLink>
            </MenuItemGroup>
          </>
        }
      >
        <Avatar
          initial={user.data?.name.charAt(0)}
          src={user.data?.profilePicURL ?? undefined}
          className="h-9 w-9"
        />
      </Menu>
    </>
  );
};

export default UserMenuDropdown;
